import type { CalendarSource } from './types';

export function isCalendarSourceEventEligible(source: CalendarSource): boolean {
  return (
    source.visible &&
    source.lifecycleState === 'active' &&
    !source.projectionError &&
    !source.presentationError
  );
}
